class CollectionDescription {
  constructor() {
    this.init();
  }

  init() {
    this.descriptionWrappers = document.querySelectorAll('[data-collection-description]');
    
    if (this.descriptionWrappers.length > 0) {
      this.setupDescriptions();
      this.bindEvents();
      
      window.addEventListener('resize', this.debounce(() => {
        this.setupDescriptions();
      }, 250));
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  setupDescriptions() {
    this.descriptionWrappers.forEach((wrapper, index) => {
      const content = wrapper.querySelector('[data-description-content]');
      const button = wrapper.querySelector('[data-read-more-button]');
      const showReadMore = wrapper.getAttribute('data-show-read-more') === 'true';
      const maxLines = parseInt(wrapper.getAttribute('data-max-lines')) || 4;
      
      if (!content) return;
      
      if (!showReadMore) {
        if (button) button.style.display = 'none';
        return;
      }
      
      requestAnimationFrame(() => {
        const actualLines = this.countTextLines(content);
        
        if (actualLines > maxLines) {
          if (button) button.style.display = 'inline-flex';
        } else {
          content.classList.remove('collection-description__content--clamp');
          if (button) button.style.display = 'none';
        }
      });
    });
  }

  countTextLines(element) {
    const originalStyle = element.style.cssText;
    const originalClass = element.className;
    
    element.style.overflow = 'visible';
    element.style.display = 'block';
    element.style.webkitLineClamp = 'none';
    element.style.maxHeight = 'none';
    element.style.height = 'auto';
    element.style.webkitBoxOrient = 'initial';
    
    element.offsetHeight;
    
    setTimeout(() => {}, 0);
    
    const computedStyle = getComputedStyle(element);
    const lineHeight = parseFloat(computedStyle.lineHeight);
    const elementHeight = element.scrollHeight;
    const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
    const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
    
    const contentHeight = elementHeight - paddingTop - paddingBottom;
    
    const lines = Math.ceil(contentHeight / lineHeight);
    
    element.style.cssText = originalStyle;
    element.className = originalClass;
    
    return lines;
  }



  bindEvents() {
    this.descriptionWrappers.forEach((wrapper, index) => {
      const content = wrapper.querySelector('[data-description-content]');
      const button = wrapper.querySelector('[data-read-more-button]');
      
      if (!content || !button) return;
      
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleReadMore(content, button);
      });
      
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleReadMore(content, button);
        }
      });
    });
  }

  handleReadMore(content, button) {
    const isExpanded = content.classList.contains('expanded');
    const readMoreText = button.querySelector('.read-more-text');
    const readLessText = button.querySelector('.read-less-text');
    
    if (isExpanded) {
      content.classList.remove('expanded');
      content.classList.add('collection-description__content--clamp');
      
      button.setAttribute('aria-expanded', 'false');
      if (readMoreText) readMoreText.style.display = 'inline';
      if (readLessText) readLessText.style.display = 'none';
      
      this.scrollToTop(content);
    } else {
      content.classList.add('expanded');
      content.classList.remove('collection-description__content--clamp');
      
      button.setAttribute('aria-expanded', 'true');
      if (readMoreText) readMoreText.style.display = 'none';
      if (readLessText) readLessText.style.display = 'inline';
    }
  }

  scrollToTop(element) {
    const rect = element.getBoundingClientRect();
    const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
    
    if (!isVisible) {
      element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionDescription();
  });
} else {
  new CollectionDescription();
}

window.CollectionDescription = CollectionDescription;
